import MapHomeComponent from '../components/map-home.component'
import parallaxComponent from '../components/parallax.component'
import TabsHomeComponent from '../components/tabs-home.component'

export default class HomeService {
    constructor() {
        new TabsHomeComponent()
        new MapHomeComponent()
        new parallaxComponent()

        if ($('[data-trigger="wpiris-filter-agenda"]').length > 0) {
            import(
                '@scripts/components/agenda-filter.component' /* webpackChunkName: "scripts/agenda-filters.component" */
            ).then(({ default: AgendaFiltersComponent }) => {
                new AgendaFiltersComponent()
            })
        }

        if ($('.strate--agenda .events[data-hc-slider]').length > 0) {
            $.fn.onClassChange = function (cb) {
                return $(this).each((_, el) => {
                    new MutationObserver((mutations) => {
                        mutations.forEach((mutation) =>
                            cb?.(mutation.target, mutation.target.className),
                        )
                    }).observe(el, {
                        attributes: true,
                        attributeFilter: ['class'], // only listen for class attribute changes
                    })
                })
            }

            $('.strate--agenda .events[data-hc-slider]').onClassChange((el, className) => {
                if (className.includes('swiper-initialized')) {
                    el.swiper.params.speed = 1500
                }
            })
        }

        //Managing scroll reveal for sections
        const sectionViewObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('viewed')
                        entry.target.classList.add('in-view')
                    } else {
                        entry.target.classList.remove('in-view')
                    }
                })
            },
            { rootMargin: '-15%' },
        )
        document.querySelectorAll('section').forEach((section) => {
            sectionViewObserver.observe(section)
        })

        //Managing scroll reveal for data-appear-order elements & others (the only difference is the rootMargin)
        const dataAppearOrderViewObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('viewed')
                        entry.target.classList.add('in-view')
                    } else {
                        entry.target.classList.remove('in-view')
                    }
                })
            },
            { rootMargin: '0px' },
        )

        dataAppearOrderViewObserver.observe(document.querySelector('.home'))

        document.querySelectorAll('[data-appear-order]').forEach((section) => {
            dataAppearOrderViewObserver.observe(section)
        })

        $('[data-appear-order]').each(function () {
            $(this).css({ transitionDelay: `${$(this).data('appear-order') * 0.75}s` })
        })
    }
}
